import { cn } from '@/lib/utils'
import { Order, OrderStatus } from '@/types'
import { useTranslation } from 'next-i18next'
import React from 'react'

export const statusColorMap: Record<string, string> = {
  scheduled: 'text-success',
  placed: 'text-success',
  ongoing: 'text-success',
  delayed: 'text-danger',
  delay: 'text-danger',
  completed: 'text-stone-400',
  canceled: 'text-danger',
  waiting_confirmation: 'text-warning',
  voucher: 'text-orange-400',
}

const OrderStatusBadge = ({ order }: { order: Order }) => {
  const { t } = useTranslation('order')

  if (order.isBlocked && order.status !== OrderStatus.Canceled) {
    return (
      <div className="text-sm capitalize space-x-1 text-danger">
        {t('booking_locked')}
      </div>
    )
  }

  return (
    <div
      className={cn(
        'text-sm capitalize space-x-1 ' + statusColorMap[order.status]
      )}
    >
      <span>{t('status.' + order.status)}</span>
    </div>
  )
}

export default OrderStatusBadge
